import React, {Component, Fragment} from 'react';

import DatePicker from "react-datepicker";
import axios from '@app/lib/axios';

import * as Constant from '@app/Constant.js';

import "./datepicker_custom.css";


const CustomDatepicker = ({value, onClick}) => {

	return (
		<div className="input-group mb-3">
	        <input type="text" name="request_date" className="form-control" readOnly="readOnly" value={value} onClick={onClick}/>
	        <div className="input-group-append">
	            <button type="button" className="btn btn-primary" onClick={onClick}><i className="fas fa-calendar-alt"></i></button>
	        </div>
	    </div>
	)
};


const ActionButtons = ({id, isAction, editable, formSubmitFn, resetFn, deleteFn}) => {
        if(id) {
            if(editable) {
                return (
                    <Fragment>
                        <button type="button" className="btn btn-rounded btn-info" value="리셋" tabIndex="13" disabled={isAction ? "disabled" : ""} onClick={resetFn}>리셋</button>&nbsp;
                        <input type="button" className="btn btn-rounded btn-success" value="수정" tabIndex="14" disabled={isAction ? "disabled" : ""} onClick={formSubmitFn} />&nbsp;
                        <button type="button" className="btn btn-rounded btn-danger" tabIndex="15" disabled={isAction ? "disabled" : ""} onClick={deleteFn}>삭제</button>
                    </Fragment>
                )
            } 
            return (
                <Fragment>
                    <button type="button" className="btn btn-rounded btn-info" value="리셋" tabIndex="13" disabled={isAction ? "disabled" : ""} onClick={resetFn}>리셋</button>&nbsp;
                </Fragment>
            )
        } else {
            
           return (
                <input type="submit" className="btn btn-rounded btn-primary" value="저장" tabIndex="13" disabled={isAction || !editable ? "disabled" : ""} onClick={formSubmitFn}/>
           )
        }
    }



class Form extends Component {
	

    formInitData = {
        id : 0,
        user_id : 0,
        product : 4,
        device : "",
        storage : "",
        version : "",
        type : 18,
        organization : "",
        requestor : "",
        phone : "",
        
        question : "",
        answer : "",
        is_complete : "N",
        is_issue : "N",
        request_date : new Date(),

        editable : localStorage.getItem("login_user_type") === 'admin'
    }

	
    constructor(props) {
        super(props);

        this.state = {
            products :this.props.products,
            types : this.props.types,
            ... this.formInitData,
            action : false
        }
    }
   

    componentWillReceiveProps = (nextProps) => {
        var types = [];

        nextProps.products.map(product => {
            if(product.id == nextProps.csData.product) {
                types = product.types;
            }
            return null;
        });
        


        this.setState({
            id : nextProps.csData ? nextProps.csData.id : 0,
            user_id : nextProps.csData.user_id ,
            product : nextProps.csData.product ,
            device : nextProps.csData.device ,
            storage : nextProps.csData.storage ,
            version : nextProps.csData.version ,
            types : types,
            type : nextProps.csData.type ,
            organization : nextProps.csData.organization ,
            requestor : nextProps.csData.requestor ,
            phone : nextProps.csData.phone ,
            
            question : nextProps.csData.question ,
            answer : nextProps.csData.answer ,
            is_complete : nextProps.csData.is_complete,
            is_issue : nextProps.csData.is_issue,
            request_date : nextProps.csData.request_date,

            editable : nextProps.csData.user_id ? 
                    nextProps.csData.user_id == localStorage.getItem("login_user_index") && localStorage.getItem("login_user_type") === 'admin': localStorage.getItem("login_user_type") === 'admin'
        });
    }


    formReset = () => {
        this.setState({
            action : false,
            ...this.formInitData
        });
    }

    
	handleDateChange = (date) => {
        if(this.state.editable) {
            this.setState({
                request_date : date
            });
        }
    }

	handleChange = (e) => {
        
        const target = e.target;
        const value = target.name == 'is_complete' || target.name == 'is_issue' ? (target.checked ? "Y" : "N") : target.value;
        const name = target.name;
        
        var stateData = {
            [name] : value
        }

        if(name == "product") {
            var types = [];
            if(value == 5) {
                this.props.products.map(product => {
                    types = Array.prototype.push.apply(types, product.types);
                    return null;
                });
            } else {
                this.props.products.map(product => {
                    if(product.id == value ) {
                        types = product.types;
                    }
                    return null;
                });
            }
            

            stateData.types = types;

        }
        
		this.setState(stateData);
	};


    onFormSubmit = (e) => {
        
        if(e) e.preventDefault();

        
        if(!this.state.product) {
            alert("상품을 선택 해주세요.");
            return;
        }

        if(!this.state.type) {
            alert("메뉴 분류를 선택 해주세요.");
            return;
        }

        if(!localStorage.getItem("login_user_index")) {
            alert("사용자 정보를 찾을 수 없습니다. 로그아웃 후 재로그인 해주세요.");
            return;
        }

        this.setState({
            action : true
        });
        

        var url = Constant.API_DOMAIN+"/api/cs_info/create";
        if(this.state.id && this.state.id > 0) {
            url =Constant.API_DOMAIN+"/api/cs_info/update";
        }

        axios({
          method: "post",
          url: url,
          data: {
            user_id : localStorage.getItem("login_user_index"),

            id : this.state.id,
            product : this.state.product,
            device : this.state.device,
            storage : this.state.storage,
            version : this.state.version,
            type : this.state.type,
            organization : this.state.organization,
            requestor : this.state.requestor,
            phone : this.state.phone,
            
            question : this.state.question,
            answer : this.state.answer,
            is_complete : this.state.is_complete,
            is_issue : this.state.is_issue,
            request_date : this.state.request_date
          }
        })
          .then(result => {

            alert(result.data.msg);
       
            
            this.props.listCallFn(this.state.request_date);
            this.formReset(e); 
            
            

          })
          .catch(error => {
            console.log(error);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            this.setState({
                action : false
            });
        });
    }


    deleteData = () => {
        if(!this.state.id || this.state.id <= 0) {
            alert("데어터가 존재하지 않습니다.");
            return;
        }

        axios({
          method: "delete",
          url: Constant.API_DOMAIN+"/api/cs_info/delete",
          data: {
            user_id : localStorage.getItem("login_user_index"),

            id : this.state.id
          }
        })
          .then(result => {

            alert(result.data.msg);
       
            this.formReset(); 
            this.props.listCallFn();
            

          })
          .catch(error => {
            console.log(error);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            this.setState({
                action : false
            });
        });

    }

	render() {
        // console.log(this.props.csData.is_complete == 'Y')
		return (
            <Fragment>
                <div className="form-row">
                    <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-2">
                        <label htmlFor="product_select">상품</label>
                        <input type="hidden" name="id" value={this.state.id}/>
                        <input type="hidden" name="user_id" value={this.state.user_id}/>
                        <select className="form-control" id="product_select" name="product" tabIndex="1" autoFocus onChange={this.handleChange} value={this.state.product} disabled={!this.state.editable} >
                            {
                                this.props.products.map((product) => {
                                    return <option id={"product_id_" + product.id }  value={product.id}>{product.name}</option>
                                })
                            }
                        </select>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-2">
                        <label htmlFor="type_select">메뉴 분류</label>
                        <select className="form-control" id="type_select" name="type"  tabIndex="2" onChange={this.handleChange}  value={this.state.type} disabled={!this.state.editable} >
                            {
                                this.state.types.map(type => {
                                    return <option id={"type_id_" + type.id } value={type.id}>{type.name}</option>
                                })
                            }
                        </select>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-2">
                        <label tabIndex="validationCustom05" htmlFor="request_date">날짜</label><br/>
                        <DatePicker
                        	name="request_date"
							selected={this.state.request_date}
							onChange={this.handleDateChange}
							customInput={<CustomDatepicker />}
							dateFormat="yyyy-MM-dd"
						/>
                    </div>
                </div>

                <div className="form-row">
                    <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-2">
                        <label htmlFor="organization">기관</label>
                        <input type="text" className="form-control" id="organization" name="organization" placeholder="기관" tabIndex="3" onChange={this.handleChange} value={this.state.organization} disabled={!this.state.editable}/>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-2">
                        <label htmlFor="requestor">문의자</label>
                        <input type="text" className="form-control" id="requestor" name="requestor" placeholder="문의자" tabIndex="4" onChange={this.handleChange} value={this.state.requestor} disabled={!this.state.editable}/>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-2">
                        <label htmlFor="phone">연락처</label>
                        <input type="text" className="form-control" id="phone" name="phone" placeholder="연락처" tabIndex="5" onChange={this.handleChange} value={this.state.phone} disabled={!this.state.editable}/>
                    </div>
                </div>
                <hr/>
                <div className="form-row">
                	<div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mb-2">
                		<label htmlFor="question">문의사항</label>
                        <textarea className="form-control" id="question" name="question" rows="3" tabIndex="6" onChange={this.handleChange} value={this.state.question} disabled={!this.state.editable}></textarea>
                	</div>
                	<div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mb-2">
                		<label htmlFor="answer">처리내역</label>
                        <textarea className="form-control" id="answer" name="answer" rows="3" tabIndex="7" onChange={this.handleChange} value={this.state.answer} disabled={!this.state.editable}></textarea>
                	</div>
                </div>
                <div className="form-row">
                    <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-2">
                        <label htmlFor="device">디바이스(모델)</label>
                        <input type="text" className="form-control" id="device" name="device" placeholder="디바이스(모델)" tabIndex="8" onChange={this.handleChange} value={this.state.device} disabled={!this.state.editable}/>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-2">
                        <label htmlFor="storage">저장공간</label>
                        <input type="text" className="form-control" id="storage" name="storage" placeholder="저장공간" tabIndex="9" onChange={this.handleChange} value={this.state.storage} disabled={!this.state.editable}/>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-2">
                        <label htmlFor="version">버전</label>
                        <input type="text" className="form-control" id="version" name="version" placeholder="버전" tabIndex="10" onChange={this.handleChange} value={this.state.version} disabled={!this.state.editable}/>
                    </div>
                </div>
                <hr/>
                <div className="form-row">
                	<div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mb-2">
                		<div className="custom-control custom-checkbox">
                            <input type="checkbox" className="custom-control-input is-valid" id="isComplete" name="is_complete" value="Y" checked={this.state.is_complete == 'Y'} 
                                            tabIndex="11" onChange={this.handleChange} disabled={!this.state.editable}/>
                            <label className="custom-control-label" htmlFor="isComplete">처리 완료</label>
                        </div>
                        <div className="custom-control custom-checkbox">
                            <input type="checkbox" className="custom-control-input is-valid" id="isIssue" name="is_issue" value="Y" checked={this.state.is_issue == 'Y'} 
                                            tabIndex="12" onChange={this.handleChange} disabled={!this.state.editable}/>
                            <label className="custom-control-label" htmlFor="isIssue">이슈</label>
                        </div>
                	</div>
                	<div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mb-2">
                		<div className="float-right">
                            <ActionButtons id={this.state.id} isAction={this.state.action} editable={this.state.editable} formSubmitFn={this.onFormSubmit} resetFn={this.formReset} deleteFn={this.deleteData}/> 
                        </div>
                	</div>
                </div>
            </Fragment>
		)
	}

}

export default Form;